import moment from 'moment';
import { useEffect, useState, useMemo, useCallback } from 'react';

import {
  EMPLOYEE_COLUMNS_HEADER_HEIGHT,
  ONE_MINUTE,
} from '@app/components/Calendars/components/TimeLine/constants';
import type { TimeLineType } from '@app/components/Calendars/components/TimeLine/types';
import { DATE_FORMATS } from '@app/constants';
import { calculateTopForCurrentTimeFromStartOfDay } from '@app/shared/calendar';

import '@app/components/Calendars/components/TimeLine/styles/TimeLine.desktop.scss';

export const TimeLine: TimeLineType = ({
  startOfDay,
  headerHeight = EMPLOYEE_COLUMNS_HEADER_HEIGHT,
  className = '',
}) => {
  const getCurrentTime = useCallback(
    () => moment().format(DATE_FORMATS.ISO_FORMAT_NO_TIMEZONE),
    []
  );

  const [currentTime, setCurrentTime] = useState(getCurrentTime());

  const startOfDayUTC = useMemo(
    () =>
      moment(startOfDay, 'HH:mm').format(DATE_FORMATS.ISO_FORMAT_NO_TIMEZONE),
    [startOfDay]
  );

  const position = useMemo(
    () => calculateTopForCurrentTimeFromStartOfDay(currentTime, startOfDayUTC),
    [currentTime, startOfDayUTC]
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(getCurrentTime());
    }, ONE_MINUTE);

    return () => clearInterval(timer);
  }, [getCurrentTime]);

  return (
    <div
      style={{ top: position + headerHeight }}
      className={`current-time-line-container ${className}`}
    >
      <div className="current-time">
        <span>{moment(currentTime).format('HH:mm')}</span>
      </div>
      <div className="current-time-line" />
    </div>
  );
};
